import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={58}
            height={58}
            viewBox="0 0 58 58"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect width={58} height={58} rx={29} fill={props.isHover ? theme["#0D968F"] : "#F7FEFD"} />
        <path d="M39 25.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z" fill={props.isHover ? '#F7FEFD' : theme["#0D968F"]} />
        <path
            d="M32 32.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zM22.59 19H20c-.55 0-1 .45-1 1v2.59c0 .89 1.08 1.34 1.71.71l2.59-2.59c.62-.63.18-1.71-.71-1.71zM35.41 39H38c.55 0 1-.45 1-1v-2.59c0-.89-1.08-1.34-1.71-.71l-2.59 2.59c-.62.63-.18 1.71.71 1.71z"
            fill={props.isHover ? '#F7FEFD' : theme["#0D968F"]}
        />
        </svg>
    )
}

export default SvgComponent
